// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3KZpX","additionalInfo":"AgreementModal_additionalInfo__YD-3h"};